module.exports = __webpack_public_path__ + "img/left_top_1.0838648.png";